export default class handleToast {
    constructor(container, options) {

        const toast = container.querySelector('.js-toast');

        if (!toast) {
            return;
        }

        const cookieName = (options.label) ? 'toast-' + options.label : 'toast-message';

        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        function getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        if (getCookie(cookieName) === 1 || getCookie(cookieName) === '1') {
            return;
        }

        const progressBar = toast.querySelector('.js-toast-progress-bar');
        const closeBtn = toast.querySelector('.js-toast-close');

        const timer = (options.timer > 7 && options.timer <= 30) ? options.timer : 10; // min/max. options timer (in seconds)
        const delay = (options.delay > 0 && options.delay <= 10) ? options.delay * 1000 : 1000; // min/max. options delay (in seconds)

        if (progressBar) {
            progressBar.style.transitionDuration = timer + 's';
        }

        setTimeout(function () {
            toast.classList.add('is--visible');

            setTimeout(function () {
                toast.classList.remove('is--visible');
            }, timer * 1000);
        }, delay);

        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                toast.classList.remove('is--visible');
                setCookie(cookieName, 1, 2);
            });
        }
    }
}
